import Vue from 'vue';

const prodURL =
  window.location.origin.includes('indsiders.com') &&
  !window.location.origin.includes('dev') &&
  !window.location.origin.includes('homolog');
const homologURL = window.location.origin.includes('homolog');
const localhostURL = window.location.origin.includes('localhost');

if (prodURL) {
  Vue.prototype.$mySfcLink = 'https://mysfc-v2.indsiders.com/';
  Vue.prototype.$myConnectLink = 'https://myconnectv2.indsiders.com/';
  Vue.prototype.$myConfigLink = 'https://myconfig-v2.indsiders.com/';
  Vue.prototype.$myDashboardLink = 'https://mydashboard-v2.indsiders.com/';
  Vue.prototype.$myPlanLink = 'https://myplan-v2.indsiders.com/';
  Vue.prototype.$myForecastLink = 'https://myforecast-v2.indsiders.com/';
  Vue.prototype.$myQualityLink = 'https://myquality-v2.indsiders.com/';
  Vue.prototype.$myNotificationLink = 'https://mynotification-v2.indsiders.com/';
  Vue.prototype.$myColabLink = 'https://mycolab-v2.indsiders.com/';
} else if (homologURL) {
  Vue.prototype.$mySfcLink = 'https://mysfc-homolog.indsiders.com/';
  Vue.prototype.$myConnectLink = 'https://myconnectv2-homolog.indsiders.com/';
  Vue.prototype.$myConfigLink = 'https://myconfig-homolog.indsiders.com/';
  Vue.prototype.$myDashboardLink = 'https://mydashboard-homolog.indsiders.com/';
  Vue.prototype.$myPlanLink = 'https://myplan-homolog.indsiders.com/';
  Vue.prototype.$myForecastLink = 'https://myforecast-homolog.indsiders.com/';
  Vue.prototype.$myQualityLink = 'https://myquality-homolog.indsiders.com/';
  Vue.prototype.$myNotificationLink = 'https://mynotification-homolog.indsiders.com/';
  Vue.prototype.$myColabLink = 'https://mycolab-homolog.indsiders.com/';
} else if (localhostURL) {
  Vue.prototype.$mySfcLink = 'http://localhost:8081/';
  Vue.prototype.$myConnectLink = 'http://localhost:8082/';
  Vue.prototype.$myConfigLink = 'http://localhost:8081/';
  Vue.prototype.$myDashboardLink = 'http://localhost:8087/';
  Vue.prototype.$myPlanLink = 'http://localhost:8084/';
  Vue.prototype.$myForecastLink = 'http://localhost:8084/';
  Vue.prototype.$myQualityLink = 'http://localhost:8084/';
  Vue.prototype.$myNotificationLink = 'http://localhost:8084/';
  Vue.prototype.$myColabLink = 'http://localhost:8088/';
} else {
  Vue.prototype.$mySfcLink = 'https://mysfc-dev.indsiders.com/';
  Vue.prototype.$myConnectLink = 'https://myconnectv2-dev.indsiders.com/';
  Vue.prototype.$myConfigLink = 'https://myconfig-dev.indsiders.com/';
  Vue.prototype.$myDashboardLink = 'https://mydashboard-dev.indsiders.com/';
  Vue.prototype.$myPlanLink = 'https://myplan-dev.indsiders.com/';
  Vue.prototype.$myForecastLink = 'https://myforecast-dev.indsiders.com/';
  Vue.prototype.$myQualityLink = 'https://myquality-dev.indsiders.com/';
  Vue.prototype.$myNotificationLink = 'https://mynotification-dev.indsiders.com/';
  Vue.prototype.$myColabLink = 'https://mycolab-dev.indsiders.com/';
}
